import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ParallaxElement } from '../../../parallax/components';
import { ContentLinkList, PreloadImage, PreloadVideo } from '../../components';

import {
  BleedSectionRight,
  HeaderBlockLeft,
  HeaderContentLeft,
  FigureBlock,
  FigureContainer,
  MainFigureContainerRight,
  MainFigure,
  SupportFigurePortraitLeft,
  TriangleFigureLeft,
  TriangleImage,
  TextBlockPortraitRight,
  TextContentPortraitRight,
} from './ui';

class BleedSectionPortraitRight extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
    mainImage: PropTypes.string.isRequired,
    supportImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    supportVideo: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    supportMediaType: PropTypes.string,
    subTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    renderContent: PropTypes.func.isRequired,
    links: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  };

  render() {
    const {
      breakpoint,
      mainImage,
      supportImage,
      supportVideo,
      supportMediaType,
      subTitle,
      title,
      renderContent,
      links,
    } = this.props;

    return (
      <BleedSectionRight>
        <FigureBlock>
          <FigureContainer>
            <MainFigureContainerRight breakpoint={breakpoint}>
              <MainFigure>
                <PreloadImage src={mainImage} background />
              </MainFigure>
              {breakpoint !== 'phone' && (
                <SupportFigurePortraitLeft breakpoint={breakpoint}>
                  <ParallaxElement depth={15}>
                    {supportVideo && supportMediaType === 'video' ? (
                      <PreloadVideo src={supportVideo} />
                    ) : (
                      <PreloadImage src={supportImage} background />
                    )}
                  </ParallaxElement>
                  <TriangleFigureLeft>
                    <ParallaxElement depth={12}>
                      <TriangleImage />
                    </ParallaxElement>
                  </TriangleFigureLeft>
                </SupportFigurePortraitLeft>
              )}
            </MainFigureContainerRight>
          </FigureContainer>
        </FigureBlock>

        <HeaderBlockLeft breakpoint={breakpoint}>
          <HeaderContentLeft breakpoint={breakpoint}>
            {breakpoint !== 'phone' ? (
              <ParallaxElement depth={25}>
                <h3>{subTitle}</h3>
                <h2>{title}</h2>
              </ParallaxElement>
            ) : (
              <div>
                <h3>{subTitle}</h3>
                <h2>{title}</h2>
              </div>
            )}
          </HeaderContentLeft>
        </HeaderBlockLeft>

        <TextBlockPortraitRight breakpoint={breakpoint}>
          <TextContentPortraitRight breakpoint={breakpoint}>
            {renderContent()}
            {links && <ContentLinkList links={links} />}
          </TextContentPortraitRight>
        </TextBlockPortraitRight>
      </BleedSectionRight>
    );
  }
}

export default BleedSectionPortraitRight;



// WEBPACK FOOTER //
// ./src/modules/pages/components/sections/BleedSectionPortraitRight.js